import {Group, GroupProps, Text} from '@mantine/core';
import React from 'react';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {BenchlingNodeV2SectionInfo} from 'ui-library/reactflow/nodes/BenchlingNode/v2/useBenchlingNodeV2Context';

/**
 * A styled flex row wrapper around one or more {@link SummaryItem}.
 *
 * @package
 */
export function Summary(props: GroupProps): JSX.Element {
  const {children, ...groupProps} = props;
  return (
    <Group bg="gray.0" px="sm" py="xs" {...groupProps}>
      {children}
    </Group>
  );
}

/**
 * Renders a count of items for a section, keyed by that section's icon.
 * @package
 */
export function SummaryItem(props: {icon: BenchlingIconName; count: number}): JSX.Element {
  return (
    <Group spacing="xs">
      <BenchlingIcon style={{width: '10px', height: '10px'}} icon={props.icon} />{' '}
      <Text c="gray.6" fz="sm">
        {props.count}
      </Text>
    </Group>
  );
}

export type SectionsSummaryProps = Omit<GroupProps, 'children'> & {
  sections: Array<BenchlingNodeV2SectionInfo>;
};

/**
 * Renders a count of items for each section, keyed by that section's icon.
 *
 * This component is a context consumer. As such, it should be rendered as a child of a
 * {@link BenchlingNodeV2}.
 *
 * @package
 */
export function SectionsSummary(props: SectionsSummaryProps): JSX.Element {
  const {sections, ...restProps} = props;

  return (
    <Summary {...restProps}>
      {sections.map((section) => (
        <SummaryItem key={section.name} icon={section.icon} count={section.count} />
      ))}
    </Summary>
  );
}
